import { enumToOptions } from '@app/shared/helpers';
import { SubSector } from '@app/shared/models/contracts/enums/shared-enums';

export const SUB_SECTOR_OPTIONS = enumToOptions(SubSector, undefined, true);
